import { IState } from 'shared/store';

export const selectDailyrentOfferData = (state: IState) => {
  return state.offerData.offer?.dailyrent || null;
};
